<template>
  <div class="flex h-fit flex-col gap-2 rounded-2xl border-4 border-neutral-600 p-4">
    <span class="text-2xl">Kunde</span>
    <label for="salutation">Anrede:</label>
    <select
      id="salutation"
      name="salutation"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="customer.salutation"
      @change="dataStore.update()"
      required
    >
      <option value="">-- Bitte wählen --</option>
      <option value="Herr">Herr</option>
      <option value="Frau">Frau</option>
      <option value="Firma">Firma</option>
    </select>

    <label for="name">Name:</label>
    <input
      type="text"
      id="name"
      name="name"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="customer.name"
      @change="dataStore.update()"
      required
    />

    <label for="street">Adresse:</label>
    <input
      type="text"
      id="street"
      name="street"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="customer.street"
      @change="dataStore.update()"
      required
    />

    <label for="city">Ort:</label>
    <input
      type="text"
      id="city"
      name="city"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      list="cities"
      v-model="customer.city"
      @change="dataStore.update()"
      required
    />
    <datalist id="cities">
      <option value="6652 Elbigenalp"></option>
      <option value="6653 Bach"></option>
      <option value="6651 Häselgehr"></option>
    </datalist>
  </div>
</template>

<script setup lang="ts">
import { type Customer } from "@/types";
import { useStore } from "../stores/dataStore";

const dataStore = useStore();

const props = defineProps<{
  customer: Customer;
}>();
</script>

<style scoped></style>
